export class Constants{
	static ACTIVATION_CODE_INVALID = 'ACTIVATION_CODE_INVALID';
	static QUANTITY_OPTIONS = [25, 50, 75, 100];
	static QUANTITY = 25;
	static TOKEN_NOT_VALID = 'TOKEN_NOT_VALID';
	static NEW_CONVERSATION_MESSAGE = 'NEW_CONVERSATION_MESSAGE';
	static NEW_CONVERSATION = 'NEW_CONVERSATION';
	static CONVERSATION_TAKEN = 'CONVERSATION_TAKEN';
	static CONVERSATION_UPDATED = 'CONVERSATION_UPDATED';
	static UPDATE_STORAGE = 'UPDATE_STORAGE';
	static INITIAL_USER_INFO = 'INITIAL_USER_INFO';
	static USER_DISABLED = 'USER_DISABLED';
	static CONVERSATION_ALREADY_TAKEN = 'CONVERSATION_ALREADY_TAKEN';
	static conversationStatus = {REQUESTED:'REQUESTED', ACTIVE:'ACTIVE', TERMINATED_BY_USER:'TERMINATED_BY_USER', TERMINATED_BY_SUPPORTED:'TERMINATED_BY_SUPPORTED'};
	static conversationStatusSimplified = {REQUESTED:'REQUESTED', ACTIVE:'ACTIVE', CLOSED:'CLOSED'};
	static assessmentOptions = {HEALTHY:'HEALTHY', REACTING:'REACTING', INJURED:'INJURED', ILL:'ILL'};
	static questionTarget = {CONVERSATION:"CONVERSATION", ASSESSMENT:"ASSESSMENT"};
	static questionStatuses = {ENABLED:'ENABLED', DISABLED:'DISABLED'};
	static answerStatuses = {ENABLED:'ENABLED', DISABLED:'DISABLED'};
	static questionType = {DROPDOWN:'DROPDOWN', TEXT:'TEXT', CHECKBOX:'CHECKBOX', DATE:'DATE', CASE_SCRIPT:'CASE_SCRIPT', TIME:'TIME', RANGE:'RANGE'};
	static userStatuses = {ACTIVE:'ACTIVE', DISABLED:'DISABLED', PASSWORD_LOCKED:'PASSWORD_LOCKED',};
	static organizationUserStatuses = {ACTIVE:'ACTIVE', DISABLED:'DISABLED'};
	static messageOrientation = {LEFT:'LEFT', RIGHT:'RIGHT'};
	static casesRangeType = {YEAR:'YEAR', MONTH:'MONTH', DAY:'DAY'};
	static userResourceTypes = {VOLUNTEER:'VOLUNTEER', PAID:'PAID', OTHER:'OTHER'};
	static userRole = {ADMIN:'ADMIN', MANAGER:'MANAGER', SUPPORTER:'SUPPORTER'};
	static assessmentColors = {HEALTHY:'#00c851', REACTING:'#FDF845', INJURED:'#ff8800', ILL:'#cc0000'};
	static organizationStatuses = {ACTIVE:'ACTIVE', DISABLED:'DISABLED'};
	static organizationRequestTypes = {TEXT_MESSAGE:'TEXT_MESSAGE', TELEPHONE:'TELEPHONE', URL:'URL'};
	static organizationPSMatchingAlgorithm = {PS_PROFILE:'PS_PROFILE', DISABLED:'DISABLED'};
	static questionMetadataTypes = {
		dropDown:{RADIO:'RADIO', MULTIPLE:'MULTIPLE'},
		text:{COMMENT:'COMMENT', HEADER:'HEADER', NUMBER:'NUMBER', PHONE:'PHONE', MONEY:'MONEY', EMAIL:'EMAIL'},
		time:{SIMPLE:'SIMPLE', RANGE:'RANGE'},
		timeInputType:{TIME:'TIME', DATETIME:'DATETIME'},
		range:{'1-5':'1-5', '1-10':'1-10', '0-5':'0-5', '0-10':'0-10'},
	};
	static questionValidationConditions = {'=':'=', '>':'>', '<':'<', '>=':'>=', '<=':'<=', 'LIKE':'LIKE'};
	static dashboardTypes = {SYSTEM:'SYSTEM', QUICK_SIGHT:'QUICK_SIGHT'};
	static deleteMessageHistory = {
		'0':{id:0, name:'Never Delete'},
		'1':{id:1, name:'Delete with Prompt or by Pressing Delete Button'},
		'2':{id:2, name:'Automatically Delete'},
	}
	static chartStatus = {ACTIVE:'ACTIVE', INACTIVE:'INACTIVE'};
	static chartType = {LOG:'LOG', CONVERSATION:'CONVERSATION'};
	static conversationCreatedBy = {ANONYMOUS_USER:'ANONYMOUS_USER', USER:'USER', SYSTEM:'SYSTEM'};
	static organizationEscalationInactivityTime = 360;
	static organizationEscalationTypes = [
		{value:'ALL_NEW_CASE_RECIPIENTS', label:'All New Case Recipients'},
		{value:'CURRENT_SUPPORTER', label: 'Current Supporter'},
		{value:'ORIGINAL_SUPPORTER', label:'Original Supporter'},
		//{value:'DIRECT_MANAGER', label:'Direct Manager'},
		//{value:'ALL_MANAGERS', label:'All Managers'},
		//{value:'ADMINS', label:'Admins'},
	];
}
